import React from "react";

const ServiceContent = () => {
  return (
    <section className="bg-gray-100 py-12">
      <div className="max-w-6xl mx-auto px-6 mt-16 md:mt-20">
        <h1 className="text-4xl font-bold text-blue-900 text-center">
          Services
        </h1>
        <p className="text-center mt-1 text-2xl text-gray-700 mb-16">
          Renmin Education: Shaping Your Academic Future with Global
          Opportunities
        </p>
        <p className="text-gray-700 leading-relaxed">
          Renmin Education is a premier educational consultancy based in India,
          dedicated to helping students realize their aspirations of studying
          abroad. With years of expertise in guiding students toward successful
          admissions in top global universities, we offer personalized advice
          and services to ensure a smooth and effective journey toward higher
          education. Our mission is to make studying abroad accessible,
          providing students with the knowledge, support, and resources they
          need to succeed in the highly competitive global education market.
        </p>
        <p className="text-gray-700 leading-relaxed mt-10">
          In today’s interconnected world, a degree from an internationally
          recognized institution can significantly enhance your career
          prospects, offer personal growth, and expose you to diverse cultures.
          At Renmin Education, we understand the complexities of applying to
          universities abroad. We aim to ease this process, providing expert
          guidance to ensure students make well-informed decisions about their
          education, aligned with their individual goals and career ambitions.
        </p>
        <p className="text-gray-700 leading-relaxed mt-10">
          Whether you wish to study in the United States, the United Kingdom,
          Canada, Australia, Europe, or other prominent education hubs, Renmin
          Education is here to guide you every step of the way. Our team of
          skilled counselors works closely with students to understand their
          preferences and objectives, offering customized solutions tailored to
          their academic and professional goals.
        </p>
      </div>
    </section>
  );
};

export default ServiceContent;
